import { Link, useTheme } from '@mui/material';

import { gql } from '@graphql/__generated__';
import { useLocale } from '@shared/hooks/locale';

export const NAME_LINK_FRAGMENT = gql(/* GraphQL */ `
  fragment NameLink on users {
    id
    first_name
    last_name
    full_name
  }
`);

type Props = {
  user: {
    id: string;
    first_name?: string | null;
    last_name?: string | null;
    full_name?: string | null;
  } | null;
  obfuscate?: boolean;
  link?: boolean;
};

export const NameLink = ({ user, obfuscate, link = true }: Props) => {
  const { t } = useLocale();
  const { text } = useTheme();

  if (user == null) {
    return <span style={{ fontWeight: text.font.bold }}>{t('Unknown')}</span>;
  }

  if (obfuscate) {
    const obfuscatedLastName = user.last_name
      ? user.last_name.slice(0, 1) + '.'
      : null;

    return (
      <span style={{ fontWeight: text.font.bold }}>
        {[user.first_name, obfuscatedLastName].filter(Boolean).join(' ')}
      </span>
    );
  }

  return link ? (
    <Link
      href={`/users/${user.id}`}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'inherit',
        textDecoration: 'none',
        fontWeight: text.font.bold,
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {user.full_name}
    </Link>
  ) : (
    <span style={{ fontWeight: text.font.bold }}>{user.full_name}</span>
  );
};
